
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"32","height":"32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M3.413 14.733l7.667 7.654L9.667 23.8a.67.67 0 01-.947 0l-7.187-7.187a.666.666 0 010-.946l.934-.934a.666.666 0 01.946 0zM30.467 8.72l-.934-.947a.68.68 0 00-.946 0L15.853 20.507l-1.44-1.44 9.334-9.334a.666.666 0 000-.946l-.934-.947a.679.679 0 00-.946 0l-9.334 9.4-2.453-2.507a.668.668 0 00-.947 0l-.933.934a.666.666 0 000 .946l7.187 7.187a.666.666 0 00.946 0L30.467 9.667a.67.67 0 000-.947z"}})])
          )
        }
      }
    